// extracted by mini-css-extract-plugin
export default {"badge":"cancelDayOffArchive_badge__7-ZDo","btnsGroup":"cancelDayOffArchive_btnsGroup__INBUu","status":"cancelDayOffArchive_status__Xq4QR"};